<template>
    <div>
        <h3 class="text-center mb-8 mt-8 text-uppercase">Laporan Indikator Mutu {{ model.unit ? model.unit.name : '' }}</h3>
        <table class="table">
            <tr>
                <th scope="col" width="200">Unit</th>
                <td>{{ model.unit ? model.unit.name : '' }}</td>
            </tr>
            <tr v-if="model.unit_child">
                <th scope="col" width="200">Ruangan</th>
                <td>{{ model.unit_child.name }}</td>
            </tr>
            <tr>
                <th scope="col">Bulan</th>
                <td>{{ month }} {{ model.year }}</td>
            </tr>
            <tr>
                <th scope="col">Deskripsi</th>
                <td>{{ model.description }}</td>
            </tr>
        </table>

        <div class="card-body p-4 table-responsive">
            <table class="table table-bordered table-sm table-fixed">
                <thead class="text-uppercase text-center valign-middle">
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col" class="width-200">Indikator</th>
                        <th scope="col" class="width-100">Target Indikator</th>
                        <th scope="col" colspan="2">Data yang dilaporkan</th>
                        <th scope="col" colspan="2">Capaian</th>
                        <th scope="col" class="width-100">Ket/Analisa</th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <!-- Data yang dilaporkan -->
                        <th scope="col"></th>
                        <th scope="col" class="width-200"></th>
                        <!-- Rekapitulasi -->
                        <th scope="col" class="width-100">Angka</th>
                        <th scope="col" class="width-100">Prosentase</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, key) in items">
                    <tr class="valign-middle" :key="`item-${key}`">
                        <td :rowspan="item.report_indicator_labels.length+1">{{ key+1 }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.indicator ? item.indicator.name : '-' }}</td>
                        <td :rowspan="item.report_indicator_labels.length+1">{{ item.target_indicator_label }}</td>
                    </tr>
                    <tr class="valign-middle" :key="`detail-${key}-${detailKey}`" v-for="(detail, detailKey) in item.report_indicator_labels">
                        <!-- Data yang dilaporkan -->
                        <td class="text-center">{{ detailKey+1 }}</td>
                        <td>{{ detail.name }}</td>
                        <!-- Rekapitulasi -->
                        <td class="text-center">
                            {{ values[key][detailKey] }}
                        </td>
                        <th v-if="detailKey == 0" class="text-center" :rowspan="item.report_indicator_labels.length">
                            {{ resultLabels[key] }}
                        </th>
                        <th scope="col" class="text-center"></th>
                    </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReportRecapMonthlyView',
        props: {
            model: {
                type: Object,
                default: () => null
            },
            inputValues: {
                type: Array,
                default: () => []
            },
            items: {
                type: Array,
                default: () => []
            },
            months: {
                type: Array,
                default: () => []
            },
            monthKey: Number,
        },
        data() {
            return {
                loading: false,
                values: [],
                resultLabels: [],
            }
        },
        computed: {
            month() {
                return this.months[this.monthKey]
            }
        },
        created() {
            let resultLabels = []
            const monthKey = this.monthKey
            this.items.map((item, key) => {
                let values = []
                item.report_indicator_labels.map((detail, detailKey) => {
                    const inputValue = this.inputValues.find((val) =>
                        val.indicator_id == item.indicator_id &&
                        val.report_indicator_id == detail.report_indicator_id &&
                        val.input_year == this.model.year &&
                        val.input_month == monthKey + 1)
                    values[detailKey] = inputValue ? inputValue.value : ''
                })
                this.values.push(values) // Per Month

                resultLabels[key] = null
                if (item.result_formula) {
                    let formula = `${item.result_formula}*100`
                    values.map((value, i) => {
                        const alphabet = this.alphabet(i)
                        let val = value ? value : 0
                        formula = formula.replace(`[${alphabet}]`, val)
                    })
                    resultLabels[key] = this.normalizeEval(formula, 3)
                }
            })
            this.resultLabels = resultLabels // Hasil per Indikator dalam persen
        }
    }
</script>
